import React, { Fragment } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

//kevin here
export const NavWithReactRouterDomLink = props => {

    const {
        name,
        text,
        icon,
        path,
        visibility,
        iconPrefix = 'fas',
        itemClassName
    } = props;

    const className = classnames(
        'usa-sidenav__item',
        itemClassName
    );

    return (
        <Fragment key={name}>
            {visibility &&
                <li className = { className } >
                    <div className="grid-row flex-no-wrap">
                        { icon && <FontAwesomeIcon icon={[iconPrefix, icon]} className="grid-col-1 icon"/> }
                        <Link
                            to={path}
                            id={name}
                        >
                            <FormattedMessage
                                id = {text}
                            />
                        </Link>
                    </div>
                </li>
            }
        </Fragment>

    );
};

export const NavWithLinks = ( props ) => {
    
    const {
        name,
        text,
        icon,
        path,
        links,
        visibility,
        replacements,
        cursorNotAllowed = false,
        blank = false,
        iconPrefix = 'fas',
        itemClassName
    } = props;

    const url = path && replacements && Object.keys(replacements).length > 0 ? path.processReplacements(replacements) : path;
    const link = path && links && links[path] !== null && links[path] !== undefined ? links[path] : url;

    const className = classnames(
        'usa-sidenav__item',
        itemClassName
    );

    return (
        <Fragment key={name}>
            {visibility &&
                <li className = { className } >
                    <div className="grid-row flex-no-wrap">
                        {icon && <FontAwesomeIcon icon={[iconPrefix, icon]} className="grid-col-1 icon"/>}
                        <a href={cursorNotAllowed ? null : link}
                            target={ blank ? '_blank' : undefined }
                            id={name}
                            className={`grid-col-auto ${cursorNotAllowed && 'cursor-not-allowed'}`}>
                            <FormattedMessage
                                id = {text}
                            />
                        </a>
                    </div>
                </li>
            }
        </Fragment>
    );
};

export const NavInputWithButton = ( props ) => {
    const {
        name,
        btnname,
        visibility,
        code,
        onChange,
        onSubmit,
        isDisabled,
        itemClassName
    } = props;

    const className = classnames(
        'usa-sidenav__item',
        'padding-0',
        itemClassName
    );

    return (
        <Fragment key={name}>
            {visibility &&
                <li className = { className } >
                    <form className="usa-form gi-forms">
                        <div className="grid-row flex-no-wrap">
                            <div className="mobile:grid-col-12 tablet:grid-col-fill">
                                <label className="usa-label usa-sr-only" htmlFor={name}>
                                    <FormattedMessage id="sidenav_header_accesscode" />
                                </label>
                                <input
                                    className="usa-input"
                                    id={name}
                                    data-automation-id={name}
                                    name={name}
                                    btnname={btnname}
                                    type="text"
                                    value={code}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="mobile:grid-col-12 tablet:grid-col-auto">
                                <button onClick={() => onSubmit()}
                                    className="usa-button gi-button gi-button__primary gi-button--small" data-automation-id={name} disabled={isDisabled}>
                                    <FormattedMessage
                                        id = {btnname}
                                    />
                                </button>
                            </div>
                        </div>
                    </form>
                </li>
            }
        </Fragment>
    );
};

export const NavWithModal = ( props ) => {
    const {
        name,
        text,
        path,
        icon,
        visibility,
        onClick,
        iconPrefix = 'fas',
        itemClassName
    } = props;

    const className = classnames(
        'usa-sidenav__item',
        itemClassName
    );

    return visibility && (
        <Fragment key={name}>
            <li className = { className } >
                <div className="grid-row flex-no-wrap">
                    <FontAwesomeIcon icon={[iconPrefix, icon]} className="grid-col-1 icon"/>
                    <a href={ path } onClick={ onClick } id={ name } data-automation-id={ name } className="grid-col-auto">
                        <FormattedMessage
                            id = {text}
                        />
                    </a>
                </div>
            </li>
        </Fragment>
    );
};
